import { Component, Input } from '@angular/core';

/**
 * Overlapping row of circular images with a "+N" bubble once the list runs past `max`.
 * Each entry needs a `name`, and optionally an `image` url - entries without one fall back to their initial.
 * An entry with neither is left as an empty circle rather than being stood in for.
 */
@Component({
	selector: 'ui-avatar-stack',
	template: `
		<span class="avatar-stack d-inline-flex align-items-center">
			<ng-container *ngFor="let item of items; let i = index">
				<span *ngIf="i < max"
					class="avatar border bg-white border-silver rounded-circle shadow-sm"
					[style.backgroundImage]="item[imageField] ? ('url(\\'' + item[imageField] + '\\')' | safeStyle) : null"
					[ngbTooltip]="item[nameField] || fallbackName">
					<span *ngIf="!item[imageField] && item[nameField]" class="text-secondary text-tiny text-uppercase">{{ item[nameField].charAt(0) }}</span>
				</span>
			</ng-container>
			<span *ngIf="items?.length > max" class="avatar border bg-white border-silver rounded-circle shadow-sm">
				<span class="text-secondary text-tiny">+{{ items.length - max }}</span>
			</span>
		</span>
	`,
	styles: [`
		.avatar-stack .avatar {
			display: inline-grid;
			align-items: center;
			justify-items: center;
			text-align: center;
			background-position: center center;
			background-size: contain;
			background-repeat: no-repeat;
			width: 2rem;
			height: 2rem;
			margin-right: -0.5rem;
		}

		.avatar-stack .avatar:last-child {
			margin-right: 0;
		}
	`]
})
export class UIAvatarStackComponent {
	@Input() items: any[] = [];
	@Input() max = 3;
	@Input() nameField = 'name';
	@Input() imageField = 'image';
	// What an entry with no name is called on hover. The circle itself stays empty - there's no initial to draw, and
	// a stand-in glyph reads as an entry of its own rather than as an absence.
	@Input() fallbackName = '';
}
